import { ReactElement } from 'react';
import { NumberField, NumberFieldProps } from 'react-admin';

type Props = NumberFieldProps & {
  currency?: string;
};

export function CurrencyAmountField({ currency = 'AUD', ...props }: Props): ReactElement {
  return <NumberField options={{ style: 'currency', currency }} {...props} />;
}
